import type { ReactNode } from 'react'
import { usePermissions } from '../hooks/usePermissions'
import { AccessDenied } from './AccessDenied'

interface ManagerRouteProps {
  children: ReactNode
}

export function ManagerRoute({ children }: ManagerRouteProps) {
  const { isManager } = usePermissions()

  if (!isManager) return <AccessDenied required="manager" />

  return <>{children}</>
}
